import BarChartIcon from '@mui/icons-material/BarChart';
import InsightsIcon from '@mui/icons-material/Insights';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import PsychologyIcon from '@mui/icons-material/Psychology';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface AIAssessmentChipProps {
    urgency: 'Urgent' | 'Prioritize' | 'Backlog' | 'Not Important';
    technical: 'Important' | 'Not Important';
    contextual: 'Important' | 'Not Important';
    score: number;
}

const AIAssessmentChip: React.FC<AIAssessmentChipProps> = ({ urgency, technical, contextual, score }) => {
    return (
        <Box sx={{
            px: 2,
            py: 2,
        }}>
            <Box sx={{mb:1}}>
                <Typography variant="overline" sx={{  ml: 1 }}>
                    AI Assessment
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1,


                    flexWrap: 'wrap',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <PriorityHighIcon fontSize="small" sx={{ color: urgency === 'Urgent' ? '#d32f2f' : '#f57c00' }} />
                    <Typography variant="body2">{urgency}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <PsychologyIcon fontSize="small" sx={{ color: technical === 'Important' ? '#8e24aa' : '#9e9e9e' }} />
                    <Typography variant="body2">Tech: {technical}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <InsightsIcon fontSize="small" sx={{ color: contextual === 'Important' ? '#1976d2' : '#9e9e9e' }} />
                    <Typography variant="body2">Context: {contextual}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <BarChartIcon fontSize="small" sx={{ color: score > 70 ? '#c62828' : '#616161' }} />
                    <Typography variant="body2">{score}/100</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default AIAssessmentChip;
